import { ExtendedOrderCache } from '../../../lib/cache/ExtendedOrderCache';
import { authenticatedFetchWithTenantAnalytics, useAnalytics, useTenant } from '@parcel2go/npm-p2g-app';
import { useAuth } from 'react-oidc-context';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { ApiResponse } from '~/lib/api/api-response';
import { capturePromiseException } from '~/lib/metrics';
import { GetRefundsResponse, Refund } from '~/lib/api/me/types';
import { getApiPath } from '~/lib/api/me/get-api-path';
import useSWR from 'swr';
import { useEffect } from 'react';

const useSupportBackgroundTask = () => {
  const { session } = useAnalytics();
  const { tenant, settings } = useTenant();
  const { user } = useAuth();

  const { data } = useSWR<Refund[]>(
    SettingsCache.settings.Features.includes('Support') ? `${tenant}/refunds/background` : null,
    async () => {
      const res: ApiResponse<GetRefundsResponse> = await authenticatedFetchWithTenantAnalytics(
        user,
        tenant,
        settings,
        session,
        getApiPath(tenant, `/refund`)
      )
        .then((res) => res.json())
        .catch(capturePromiseException);

      if (res.success && res.result) {
        return res.result.refunds;
      }
      return null;
    },
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateIfStale: false,
      revalidateOnMount: false,
      refreshWhenHidden: false,
      refreshInterval: (d) => (d === undefined ? 100 : 15 * 60000) // refresh every 15 minutes
    }
  );

  useEffect(() => {
    if (data?.length > 0) {
      data.forEach((x) => {
        if (!ExtendedOrderCache.refundOrderLineIds.find((c) => c.orderlineId === x.orderLineId.toString())) {
          ExtendedOrderCache.refundOrderLineIds.push({
            orderlineId: x.orderLineId.toString(),
            created: new Date(x.created),
            status: x.status,
            amount: x.amount
          });
        }
      });
    }
  }, [data]);

  return data;
};

export default useSupportBackgroundTask;
